"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
require("bootstrap");
var Clipboard = require("clipboard");
var AlertLevel;
(function (AlertLevel) {
    AlertLevel[AlertLevel["Success"] = 0] = "Success";
    AlertLevel[AlertLevel["Info"] = 1] = "Info";
    AlertLevel[AlertLevel["Warning"] = 2] = "Warning";
    AlertLevel[AlertLevel["Error"] = 3] = "Error";
})(AlertLevel = exports.AlertLevel || (exports.AlertLevel = {}));
function alert(level, message, timeout) {
    if (timeout === void 0) { timeout = 3000; }
    var msgClass;
    switch (level) {
        case AlertLevel.Error:
            msgClass = "danger";
            break;
        case AlertLevel.Warning:
            msgClass = "warning";
            break;
        case AlertLevel.Info:
            msgClass = "info";
        case AlertLevel.Success:
            msgClass = "success";
    }
    var alertElement = $("\n    <div class=\"alert alert-" + msgClass + "\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button>\n        " + message + "\n    </div>\n    ");
    alertElement.css({
        "position": "fixed",
        "bottom": "40px",
        "width": "360px",
        "right": "20px",
        "box-shadow": "0 0 32px rgba(0,0,0,.8)",
        "opacity": 0,
        "z-index": 2000,
    });
    $("#main-content").append(alertElement);
    alertElement
        .animate({ opacity: 1 }, 150)
        .delay(timeout)
        .animate({ opacity: 0 }, 800, function () {
        alertElement.remove();
    });
}
exports.alert = alert;
var msgBoxDefaultButtonDef = [{
        title: "OK",
        action: function (e, m) { m.modal("hide"); },
    }];
function msgBox(message, title, buttons) {
    if (title === void 0) { title = "Alert"; }
    if (buttons === void 0) { buttons = msgBoxDefaultButtonDef; }
    var alertModal = $("#bvd3-alert-modal");
    var modalTitle = alertModal.find(".modal-title").empty();
    var modalBody = alertModal.find(".modal-body").empty();
    var modalFooter = alertModal.find(".modal-footer").empty();
    modalTitle.text(title);
    modalBody.html(message);
    var _loop_1 = function (btnDef) {
        var btn = $("<button type=\"button\" class=\"btn btn-default\">" + btnDef.title + "</button>");
        if (btnDef.classes) {
            btn.attr("class", btnDef.classes);
        }
        btn.on("click", function (e) {
            btnDef.action.call(alertModal, e, alertModal);
        });
        modalFooter.append(btn);
    };
    for (var _i = 0, buttons_1 = buttons; _i < buttons_1.length; _i++) {
        var btnDef = buttons_1[_i];
        _loop_1(btnDef);
    }
    alertModal.modal("show");
}
exports.msgBox = msgBox;
function prompt(title, defaultString, callback) {
    var alertModal = $("#bvd3-alert-modal");
    var modalTitle = alertModal.find(".modal-title").empty();
    var modalBody = alertModal.find(".modal-body").empty();
    var modalFooter = alertModal.find(".modal-footer").empty();
    modalTitle.text(title);
    var input = $("<input class=\"form-control\" type=\"text\"/>");
    input.val(defaultString);
    modalBody.append(input);
    var btn = $("<button type=\"button\" class=\"btn btn-default\">OK</button>");
    btn.on("click", function (e) {
        alertModal.modal("hide");
        callback.call(null, input.val());
    });
    modalFooter.append(btn);
    alertModal.modal("show");
}
exports.prompt = prompt;
function copyDialog(message, title, text, callback) {
    var alertModal = $("#bvd3-alert-modal");
    var modalTitle = alertModal.find(".modal-title").empty();
    var modalBody = alertModal.find(".modal-body").empty();
    var modalFooter = alertModal.find(".modal-footer").empty();
    modalTitle.text(title);
    var input = $("<textarea class=\"form-control\" id=\"bvd3-copy-input\" rows=\"10\"></textarea>");
    input.val(text);
    modalBody.append(input);
    var btnCopy = $("<button type=\"button\" class=\"btn btn-default btn-copy\"\n                        data-clipboard-target=\"#bvd3-copy-input\">Copy</button>");
    var btnClose = $("<button type=\"button\" class=\"btn btn-default\">Close</button>");
    btnClose.on("click", function (e) {
        alertModal.modal("hide");
    });
    modalFooter.append(btnCopy);
    modalFooter.append(btnClose);
    var cb = new Clipboard(".btn-copy");
    cb.on("success", function (e) {
        alertModal.modal("hide");
        if (typeof callback === "function") {
            callback.call(null, true);
        }
    });
    alertModal.modal("show");
}
exports.copyDialog = copyDialog;
$(function () {
    $("body").append("\n    <div class=\"modal fade\" id=\"bvd3-alert-modal\" tabindex=\"-1\" role=\"dialog\">\n        <div class=\"modal-dialog\" role=\"document\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <h4 class=\"modal-title\">Alert</h4>\n                </div>\n                <div class=\"modal-body\">\n                </div>\n                <div class=\"modal-footer\">\n                </div>\n            </div><!-- /.modal-content -->\n        </div><!-- /.modal-dialog -->\n    </div>");
});
//# sourceMappingURL=notification.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/ui/notification.js
// module id = 875
// module chunks = 0 1